<template>
  <v-select
    v-model="selectedConnection"
    :items="user.cloudData"
    :label="$t('connection')"
    item-text="name"
    item-value="code"
    class="toolbar-select connection-select"
    return-object
    hide-details
    :menu-props="{ offsetY: true }"
    outlined
    dense
  >
  </v-select>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "ConnectionSelect",
  data: () => ({
    selectedConnection: null,
  }),
  computed: {
    ...mapState(["user", "connection"]),
  },
  watch: {
    connection: {
      immediate: true,
      handler(val) {
        this.selectedConnection = JSON.parse(JSON.stringify(val));
      },
    },
    selectedConnection: {
      deep: true,
      handler(val) {
        if (val.name !== this.connection.name) {
          this.selectHotel(null);
          this.setConnection(val);
          if (this.$route.name !== "dashboard") {
            this.$router.push("dashboard");
          }
          this.$emit("close-dialog");
        }
      },
    },
  },
  methods: {
    ...mapActions(["selectHotel", "setConnection"]),
  },
};
</script>
